import { render, staticRenderFns } from "./JwlButton.vue?vue&type=template&id=77cb8f64&"
import script from "./JwlButton.vue?vue&type=script&lang=ts&"
export * from "./JwlButton.vue?vue&type=script&lang=ts&"
import style0 from "./JwlButton.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports